<ejs-dialog
  #dialog
  (close)="onDismiss()"
  [isModal]="true"
  [showCloseIcon]="true"
>
  <ng-template
    #header
    *ngIf="notification.title && notification.title.length > 0"
    >{{ notification.title }}</ng-template
  >
  <ng-template #content>
    <span>{{ notification.body }}</span>
    <button ejs-button class="e-flat e-primary" (click)="onDismiss()">
      Dismiss
    </button>
  </ng-template></ejs-dialog
>
